import { Link } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import healthSquare from './../../assets/images/health-shapes-square.svg';
import healthTriangle from './../../assets/images/health-shapes-triangle.svg';
import healthMetricsChart from './../../assets/images/health-bar-chart1.svg';
import '../health.scss';
import { gsap } from 'gsap';
import AOS from "aos";
import "aos/dist/aos.css";

export default function HealthMetrics() {

  const square1Ref = useRef();
  const square2Ref = useRef();
  const triangle1Ref = useRef();
  const triangle2Ref = useRef();

  gsap.registerPlugin(ScrollTrigger);

  useEffect(() => {

    document.addEventListener('aos:in:bar-anim', function(ev) {
      //console.log('animated in', ev);

      if (ev.detail.querySelectorAll('.progress').length > 1) {
        console.log("more than 1 progress");
        var barArray = [...ev.detail.querySelectorAll('.progress')];
      } else {
        console.log("less than 1 progress");
        var barArray = [];
        var bar = ev.detail.querySelector('.progress');
        console.log(bar);
        barArray.push(bar);
      }

      console.log(barArray);

      if (barArray && barArray.length) {
        barArray.forEach(function(barItem) {
          var fill = barItem.getAttribute('data-fill');

          if (ev.detail.classList.contains('vertical-bar-chart')) {
            barItem.style.height = fill + '%';
          }

        });
      }

      var Cont={val:0};

      if (ev.detail.querySelectorAll('.percentage').length > 1) {
        var percentageArray = [...ev.detail.querySelectorAll('.percentage')];
        console.log("more than 1 percentage");
      } else {
        var percentageArray = [];
        var percentage = ev.detail.children[0].querySelector('.percentage');
        percentageArray.push(percentage);
        console.log("less than percentage");

      }

      //console.log(percentage);

      if (percentageArray) {
        percentageArray.forEach(function(percentage) {
          var percent = percentage.getAttribute('data-to');
            gsap.to(Cont,1,{val:percent,roundProps:"val",onUpdate:function(){
              percentage.textContent = Cont.val;
            },
            ease: "none"});
          
        });
      }

      console.log(percentageArray);

    });

    document.addEventListener('aos:in:percentage', function(ev) {
      var Cont={val:0};
      var percentage = ev.detail.children[0].querySelector('.percentage');
      var percentageArray = [];
      percentageArray.push(percentage);
      //console.log(percentage);

      if (percentage) {
        percentageArray.forEach(function(percentage) {
          var percent = percentage.getAttribute('data-to');
            gsap.to(Cont,1,{val:percent,roundProps:"val",onUpdate:function(){
              percentage.textContent = Cont.val;
            },
            ease: "none"});
          
        });
      }
    });

    // Had to make some adjustments since it seemed like the animation wasn't playing nice with React. The shapes weren't incrementing exactly 90 degrees (it was adding a few degrees with decimal places) so they always rotated crooked. Possibly React strict mode causing issues. Added gsap.context, refs, and using GSAP's ScrollTrigger instead of AOS. 
    let ctx = gsap.context(() => {

      var tl = gsap.timeline({ 
        onComplete:rotateAgain,
        scrollTrigger: {
          trigger: ".shape-images"
        }
      });

      function animate(){
        tl
        .to(triangle1Ref.current, 0.5, {rotation:"+=90"})
        .to(square1Ref.current, 0.5, {rotation:"+=90"}, "+=2")
        .to(triangle2Ref.current, 0.5, {rotation:"+=90"}, "+=2")
        .to(square2Ref.current, 0.5, {rotation:"+=90"}, "+=2")
      }

      function rotateAgain(){
        gsap.delayedCall(5, animate)
      }

      animate();

    });

    return () => { ctx.revert(); /* <- cleanup! */ };

    AOS.init({
      once: true
    });
    AOS.refresh();
  }, []);

  return (
    <>
      <div className="health-metrics">

        <p id="s1" className="intro" data-aos="fade-up">See how today’s health companies track and measure direct mail.&#8288;<a href="#reference-1" className="cm-article-content__reference" aria-label="Footnote 1" title="Footnote 1"><sup aria-hidden="true">[1]</sup></a></p>
        <div className='two-cols'>
          <div className='col-right w-50'>
            <div className='rounded-box-module-wrap'>
              <div className="rounded-box-module" data-aos="fade-up">
                <h3>Checking Mail Effectiveness</h3>

                <div className='progress-bar-area vertical-bar-chart' data-aos data-aos-id="bar-anim" data-aos-offset="300">
                  <div className='progressbar-item'>
                    <div className='progress-bar'>
                      <div className='progress fill-light' data-fill="31"><span class="percentage" data-to="31" aria-hidden="true">0</span><span class="screen-reader-text">31</span>%</div>
                    </div>
                    <span className='label'>Always</span>
                  </div>
                  <div className='progressbar-item'>
                    <div className='progress-bar'>
                      <div className='progress' data-fill="53"><span class="percentage" data-to="53" aria-hidden="true">0</span><span class="screen-reader-text">53</span>%</div>
                    </div>
                    <span className='label'>Most times</span>
                  </div>
                  <div className='progressbar-item'>
                    <div className='progress-bar'>
                      <div className='progress fill-light' data-fill="15"><span class="percentage" data-to="15" aria-hidden="true">0</span><span class="screen-reader-text">15</span>%</div>
                    </div>
                    <span className='label'>Sometimes</span>
                  </div>
                  <div className='progressbar-item'>
                    <div className='progress-bar'>
                      <div className='progress fill-light' data-fill="1"><span class="percentage" data-to="1" aria-hidden="true">0</span><span class="screen-reader-text">1</span>%</div>
                    </div>
                    <span className='label'>Never</span>
                  </div>
                </div>

                <p>Although health companies check the effectiveness of direct mail most of the time, out of all the industries surveyed, they’re the least likely to always check effectiveness.</p>
              </div>
              <div className="rounded-box-module">
                <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                <p>Measuring direct mail effectiveness is critical for shaping future campaigns. By better understanding what kind of messaging, design, offers and formats work best, brands can create more effective, memorable and actionable marketing.</p>
              </div>
            </div> 
            
            <div className='personalized-box secondary'>
              <h3>Health companies are the most likely to report mail response rates of more than 25%.</h3>
              <div className='shape-images'>
                <div className='triangle triangle-1'>
                  <img ref={triangle1Ref} src={healthTriangle} alt="" />
                </div>
                <div className='square square-1'>
                  <img ref={square1Ref} src={healthSquare} alt="" />
                </div>
                <div className='triangle triangle-2'>
                  <img ref={triangle2Ref} src={healthTriangle} alt="" />
                </div>
                <div className='square square-2'>
                  <img ref={square2Ref} src={healthSquare} alt="" />
                </div>
              </div>
            </div>
          </div>

          <div className='col-left w-50'>
            <div className='rounded-box-module-wrap'>
              <div className="rounded-box-module" data-aos="fade-up">
                <h3>Measuring Mail Impact</h3>
                <div className='progress-bar-area' data-aos data-aos-id="bar-anim">
                  <div className='progressbar-item'>
                    <span className='label'>Average $ sale</span>
                    <div className='progress-bar size-small'>
                      <div className='progress' data-fill="48"><span class="percentage" data-to="48" aria-hidden="true">0</span><span class="screen-reader-text">48</span>%</div>
                    </div>
                  </div>
                  <div className='progressbar-item'>
                    <span className='label'>Customer satisfaction</span>
                    <div className='progress-bar size-small'>
                      <div className='progress' data-fill="48"><span class="percentage" data-to="48" aria-hidden="true">0</span><span class="screen-reader-text">48</span>%</div>
                    </div>
                  </div>
                </div>
                <p>Health companies typically measure the impact of direct mail by average monetary sale or customer/patient satisfaction.</p>
              </div>
              <div className="rounded-box-module">
                <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                <p>Take a full-picture view of customer or patient satisfaction, assessing reviews, complaints and repeat business rates to get an idea of what’s working and what’s not. You can also send out surveys to receive input directly—perhaps with an incentive, such as a small discount or freebie.</p>
              </div>
            </div>
            <div className='rounded-box-module-wrap'>
              <div className="rounded-box-module" data-aos="fade-up">
                <h3>Direct Mail Response Rates</h3>
                <div className='progress-bar-area' data-aos data-aos-id="bar-anim">
                  <div className='progressbar-item'>
                    <span className='label'>Less than 5%</span>
                    <div className='progress-bar size-small'>
                      <div className='progress fill-light' data-fill="7"><span class="percentage" data-to="7" aria-hidden="true">0</span><span class="screen-reader-text">7</span>%</div>
                    </div>
                  </div>
                  <div className='progressbar-item'>
                    <span className='label'>From 6% to 10%</span>
                    <div className='progress-bar size-small'>
                      <div className='progress fill-light' data-fill="13"><span class="percentage" data-to="13" aria-hidden="true">0</span><span class="screen-reader-text">13</span>%</div>
                    </div>
                  </div>
                  <div className='progressbar-item'>
                    <span className='label'>From 11% to 15%</span>
                    <div className='progress-bar size-small'>
                      <div className='progress' data-fill="23"><span class="percentage" data-to="23" aria-hidden="true">0</span><span class="screen-reader-text">23</span>%</div>
                    </div>
                  </div>
                  <div className='progressbar-item'>
                    <span className='label'>From 16% to 20%</span>
                    <div className='progress-bar size-small'>
                      <div className='progress fill-light' data-fill="18"><span class="percentage" data-to="18" aria-hidden="true">0</span><span class="screen-reader-text">18</span>%</div>
                    </div>
                  </div>
                  <div className='progressbar-item'>
                    <span className='label'>From 21% to 25%</span>
                    <div className='progress-bar size-small'>
                      <div className='progress fill-light' data-fill="22"><span class="percentage" data-to="22" aria-hidden="true">0</span><span class="screen-reader-text">22</span>%</div>
                    </div>
                  </div>
                  <div className='progressbar-item'>
                    <span className='label'>More than 25%</span>
                    <div className='progress-bar size-small'>
                      <div className='progress fill-light' data-fill="16"><span class="percentage" data-to="16" aria-hidden="true">0</span><span class="screen-reader-text">16</span>%</div>
                    </div>
                  </div>
                </div>
                <p>Most health businesses report direct mail response rates of 11%–15%. But out of all industries surveyed, health companies are the most likely to have response rates of more than 25%.</p>
              </div>
              <div className="rounded-box-module">
                <div className='heading-tag'><span className='heading-tag_span'>Pro tip</span></div>
                <p id="s2">Make it quick and easy for patients or customers to respond to your mailpiece. Including a QR Code<sup>&reg;</sup>,<a href="#reference-2" class="cm-article-content__reference" aria-label="Footnote 2" title="Footnote 2"><sup aria-hidden="true">[2]</sup></a> a telephone number unique to your mail campaign, or a <strong><a href="/../6-ways-to-measure-your-next-direct-mail-campaign/">personalized URL (PURL)</a></strong> can create a customized, seamless experience that encourages them to engage.</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}
